var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiraGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_737_53169",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_737_53169",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAsNJREFUWEellruq6kAUhieJ19S2iiCKj3HOewhuG0ErbQ2SRNS0ViI2xwO+x3kKCxEEa2tjvCRz+AdGsre5jgMhCcnM/61/rayJRD4Ys9lMx3RN00zRZSTRiaPRSFdV1cB8SZIMUQghgFarpVerVaNQKLz4RSFSA0BcURSjXq+/mScCkQqg2+3qt9vNyOfzpFKpBGYvLURigH6/r7uuaziOQ6IA0tZEIoDBYKB7nmfcbjeCQ5IkUqvVIus3qROxAKh22P54PJj4/X4nuG40GkSW5Y8hIgEsy9Ivl4sBUR798/kkSEOpVGJH3IhzIhQA4pRSZjsitm2bQBzXAMCoVqskm83GMUT2iUAALo6VXddlgtx+uOF5Hrler0RVVVIul2MBogrzDcAvzlcGAKKHCwDideA4TqfZbKIW/iShCErHN4Agcb8LvBAB47puZ7VabfB8Mpl8iUK8AMLEeWQ8aqTi+Xx2FosFE+dDFIIBxInjHUopqwVEPp/Pv4l/AiFZlvWLUvovSQ4ppR1N0wLFRSAopb9TARBCvkaj0d8o2Pl83vY8LxKSz2cAuJnNZoYkSeznIsEIhdA0rS3L8iaXy7F2HTUopeZ4PDZeb30KMRwO24qibLBRoTllMplQfS7O+oP/LVGIXq/HIocoB8A5aK/wi78BiKRjt9tBdIOoYb2iKKxDAgb3/vFTPBAgLcTpdGIdslgssrwjcgjj7HchSDwUIA0EuuPxeGSB4h+R5x8u4BpHmHgkQBqI8/lMcACA1wGHyefzrNrDKjL2hyRJYWKD2u/3LFpuP86FQsGcTqeh4rEOcOokEIfDgbVrX+7NxWIRKZ4YIEk6UIzYK2C9oijmcrmMFU8FEAfBAZDz9XqdSDw1QBQEasB1XXO73SYWFwIIgoD1x+MxtbgwwE8I27Zjq134M4za0fB14Lmmaals96/5H3Afy8KJ9OsJAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraGrey);
export default __webpack_public_path__ + "static/media/jira_grey.7cfbf6d0825301956cc16a799d801219.svg";
export { ForwardRef as ReactComponent };